import axios from "axios";
import { useEffect, useState } from "react";
import YouTubePlayer from "../components/YoutubePlayer";

const Test2 = () => {
  return (
    <>
      <div>
        <YouTubePlayer
          videoId={"ubc31lVozbY?si=HhAXM8hiAXeRZlir"}
          width={400}
          height={225}
        />
        <YouTubePlayer
          videoId={"tm2N4gntigI?si=_12bEoTzIhdjAxnV"}
          width={400}
          height={225}
        />
      </div>
    </>
  );
};

export default Test2;
